// client/src/components/Navbar.js
import React from "react";
import { Link, NavLink } from "react-router-dom";

export default function Navbar() {
  return (
    <header className="w-full backdrop-blur-xl bg-black/20 border-b border-white/10 sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">

        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 hover:opacity-80">
          <img src="/logo.png" alt="smsorbit" className="w-10 h-10 rounded-xl" />
          <span className="font-bold text-xl tracking-wide">SMSOrbit</span>
        </Link>

        {/* Main Navigation */}
        <div className="hidden md:flex items-center gap-8 text-sm">
          <NavLink to="/about" className="hover:text-purple-300">About Us</NavLink>
          <NavLink to="/features" className="hover:text-purple-300">Features</NavLink>
          <NavLink to="/services" className="hover:text-purple-300">Services</NavLink>
          <NavLink to="/blogs" className="hover:text-purple-300">Blog</NavLink>
          <NavLink to="/terms" className="hover:text-purple-300">Terms</NavLink>
          <NavLink to="/api-docs" className="hover:text-purple-300">API</NavLink>
          <NavLink to="/contact" className="nav-link">  Contact Us </NavLink>
        </div>

        {/* Auth Buttons */}
        <div className="flex items-center gap-4">
          <Link to="/login" className="px-4 py-1.5 rounded-lg bg-white/10 hover:bg-white/20">
            Login
          </Link>
          <Link
            to="/register"
            className="px-4 py-1.5 rounded-lg bg-purple-600 hover:bg-purple-700 shadow-md shadow-purple-500/40"
          >
            Sign Up
          </Link>
        </div>
      </nav>
    </header>
  );
}
